import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getState } from '../helpers/App';
import {
  fetchCollection,
  updateCollectionOnCollectionsList,
  deleteCollectionFromCollectionsList,
  updateCollectionOnTree,
  removeCollectionFromTree,
  refreshCollections,
} from '../actions/Collections';

import { APIgetCollection } from '../api/Collections';

import { getParentCollection } from '../helpers/Collections';
import {
  eventSubscribe,
  eventUnsubscribe,
} from '../helpers/Events';

const EventHandler = ({ dispatch, collection }) => {
  useEffect(() => {
    const collectionCreated = (event) => {
      const newCollection = event.detail;
      if (collection) {
        const parentCollection = getParentCollection(newCollection);
        if (parentCollection && parentCollection.uuid === collection.uuid) {
          dispatch(refreshCollections());
        }
      }
    };

    eventSubscribe('collectionCreated', collectionCreated);

    return () => {
      eventUnsubscribe('collectionCreated', collectionCreated);
    };
  }, [dispatch, collection]);

  useEffect(() => {
    const collectionUpdated = (event) => {
      dispatch(updateCollectionOnCollectionsList(event.detail));
      if (event.detail.reload) {
        const state = getState();
        if (state) {
          const currentCollection = state.Collections.collection;
          if (currentCollection && currentCollection.uuid === event.detail.uuid) {
            dispatch(fetchCollection(event.detail.uuid));
          }
        }
      }
    };

    const handleUpdateCollectionOnTree = (updatedCollection) => {
      const parentCollection = getParentCollection(updatedCollection);
      dispatch(updateCollectionOnTree({
        uuid: updatedCollection.uuid,
        index: updatedCollection.index,
        name: updatedCollection.name,
        open: updatedCollection.open,
        hasChildren: true,
        parentUuid: parentCollection ? parentCollection.uuid : undefined,
      }, 'sidebar'));
    };

    const collectionUpdatedTree = (event) => {
      const updatedCollection = event.detail;
      if (!updatedCollection.index) {
        APIgetCollection(updatedCollection.uuid).then((response) => {
          updatedCollection.index = response.data.uuid;
          updatedCollection.name = response.data.name;
          updatedCollection.open = response.data.open;
          updatedCollection.ancestors = response.data.ancestors;
          handleUpdateCollectionOnTree(updatedCollection);
        });
      } else {
        handleUpdateCollectionOnTree(updatedCollection);
      }
    };

    const collectionDeleted = (event) => {
      dispatch(deleteCollectionFromCollectionsList(event.detail));
      dispatch(removeCollectionFromTree(event.detail.uuid, 'sidebar'));
    };

    eventSubscribe('collectionUpdated', collectionUpdated);
    eventSubscribe('collectionUpdatedTree', collectionUpdatedTree);
    eventSubscribe('collectionDeleted', collectionDeleted);

    return () => {
      eventUnsubscribe('collectionUpdated', collectionUpdated);
      eventUnsubscribe('collectionUpdatedTree', collectionUpdatedTree);
      eventUnsubscribe('collectionDeleted', collectionDeleted);
    };
  }, [dispatch]);

  return null;
};

const mapStateToProps = state => ({
  collection: state.Collections.collection,
});

EventHandler.propTypes = {
  dispatch: PropTypes.func.isRequired,
  collection: PropTypes.object,
};

EventHandler.defaultProps = {
  collection: null,
};

export default connect(mapStateToProps)(EventHandler);
